import { useTranslation } from 'react-i18next';
import { CircleAlert, CircleCheck, CircleDot, Clock } from 'lucide-react';
import type { Page } from './model';

/** A page's approval in lists and the tree (docs/Review.tsx): a small icon with its meaning. */
export function ApprovalBadge({ state, size = 13 }: { state: Page['approval']; size?: number }) {
  const { t } = useTranslation();
  if (!state) return null;
  const Icon = state === 'approved' ? CircleCheck : state === 'review' ? Clock : state === 'changes' ? CircleAlert : CircleDot;
  const label = t(`docs.review.badge.${state}`);
  return (
    <span className="pg-approval-badge" data-state={state} title={label} aria-label={label} role="img">
      <Icon size={size} />
    </span>
  );
}
